import { render, staticRenderFns } from "./freightPending.vue?vue&type=template&id=5d3841ba&scoped=true"
import script from "./freightPending.vue?vue&type=script&lang=js"
export * from "./freightPending.vue?vue&type=script&lang=js"
import style0 from "./freightPending.vue?vue&type=style&index=0&id=5d3841ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3841ba",
  null
  
)

export default component.exports